<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="indigo" icon="mdi-content-copy" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Consignment stocks</div>
      </template>

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-desc="[false, true]"
        multi-sort
        :custom-filter="ignoreCase"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" @click="createItem">Create new stock</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto"
              label="Search"
              hide-details
              single-line
              style="max-width: 250px;"
            />
          </v-toolbar>
          <v-divider class="mt-3" />
        </template>

        <template v-slot:item.start="{ item }">
          <span>
            {{new Date(item.start).toISOString()
            .substr(0, 10)}}
          </span>
        </template>

        <template v-slot:item.end="{ item }">
          <span>
            {{new Date(item.end).toISOString()
            .substr(0, 10)}}
          </span>
        </template>

        <template v-slot:item.statusName="{ item }">
          <span :style="{'color': getStatusColor(item.status)}">{{item.statusName}}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" @click="editItem(item)">mdi-lead-pencil</v-icon>
        </template>
      </v-data-table>
    </base-material-card>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import axios from "../../../utils/axios";
import getStockStatusColor from "../../../helpers/consignmentStockHelper";
export default {
  name: "PredefinedStocks",

  data: () => ({
    headers: [
      {
        text: "Customer",
        value: "customer.name"
      },
      {
        text: "Start date",
        value: "start"
      },
      {
        text: "End date",
        value: "end"
      },
      {
        text: "Total price",
        value: "totalValue"
      },
      {
        text: "Total in price",
        value: "totalInValue"
      },
      {
        text: "Status",
        value: "statusName"
      },
      {
        sortable: false,
        text: "Actions",
        value: "actions"
      }
    ],
    items: [],
    search: "",
    snackbar: false,
    dialog: false,
    message: "",
    snackColor: "error"
  }),

  created() {
    this.init();
  },

  methods: {
    ignoreCase(value, search, item) {
      return (
        value != null &&
        search != null &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toString().toLocaleLowerCase()) !== -1
      );
    },

    editItem(item) {
      let id = item.id;
      switch (item.status) {
        case 0: //draft
          this.$router.push({ path: `Edit/${id}` });
          break;
        case 1: //active
          this.$router.push({ path: `ActiveEdit/${id}` });
          break;
        default:
          //closed or error or without client invoice
          this.$router.push({ path: `ErrorClosedStatus/${id}` });
          break;
      }
    },

    createItem() {
      this.$router.push({ path: "Create" });
    },

    init() {
      this.getConsignmentStocks();
    },

    async getConsignmentStocks() {
      let loader = this.$loading.show();
      try {
        var result = await axios.get("/ConsignmentStock");
        if (result) {
          this.items = result.data;

          for (let i = 0; i < this.items.length; i++) {
            let statusName = this.$options.filters.getStockStatusName(
              this.items[i].status
            );
            this.items[i].statusName = this.$options.filters.getStockStatusName( this.items[i].status);
          }
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = exception;
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    },
    getStatusColor(status) {
      return getStockStatusColor(status);
    }
  }
};
</script>
